import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Button } from '../components/ui/button';
import { Label } from '../components/ui/label';
import { Mail, Send, CheckCircle2 } from 'lucide-react';
import { Alert, AlertDescription } from '../components/ui/alert';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Simulate form submission
    setTimeout(() => {
      setSubmitted(true);
      setFormData({ name: '', email: '', subject: '', message: '' });
      setTimeout(() => setSubmitted(false), 5000);
    }, 500);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="min-h-screen bg-white py-16">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
        <h1 className="text-4xl md:text-5xl font-bold text-black mb-8">
          Contacto
        </h1>

        <div className="grid md:grid-cols-2 gap-8">
          {/* Contact Info */}
          <div>
            <Card className="border-2 mb-6">
              <CardHeader>
                <CardTitle className="text-xl flex items-center gap-2">
                  <Mail className="h-5 w-5" />
                  Información de contacto
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-gray-700 mb-4">
                  ¿Tenés dudas, sugerencias o un problema técnico?
                </p>
                <p className="text-gray-700">
                  Escribinos a:{' '}
                  <a 
                    href="mailto:support@cloudcentercr.com" 
                    className="font-semibold text-black hover:underline"
                  >
                    support@cloudcentercr.com
                  </a>
                </p>
              </CardContent>
            </Card>

            <Card className="border-2 bg-gray-50">
              <CardHeader>
                <CardTitle className="text-xl">Reporte de contenido</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-gray-700 mb-4">
                  Si sos titular de derechos y querés solicitar revisión de un enlace, incluí por favor:
                </p>
                <ul className="space-y-2 text-gray-700 text-sm">
                  <li className="flex items-start gap-2">
                    <span className="text-black font-bold mt-1">•</span>
                    <span>URL del contenido (enlace exacto)</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-black font-bold mt-1">•</span>
                    <span>Descripción del reclamo</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-black font-bold mt-1">•</span>
                    <span>Prueba o información que demuestre tu relación con el contenido</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-black font-bold mt-1">•</span>
                    <span>Un correo de contacto para responderte</span>
                  </li>
                </ul>
                <p className="text-gray-700 mt-4 text-sm">
                  Respondemos en el menor tiempo posible (según volumen de solicitudes).
                </p>
              </CardContent>
            </Card>
          </div>

          {/* Contact Form */}
          <div>
            <Card className="border-2">
              <CardHeader>
                <CardTitle className="text-xl">Envianos un mensaje</CardTitle>
              </CardHeader>
              <CardContent>
                {submitted && (
                  <Alert className="mb-6 bg-green-50 border-green-200">
                    <CheckCircle2 className="h-4 w-4 text-green-600" />
                    <AlertDescription className="text-green-700">
                      ¡Mensaje enviado correctamente! Te responderemos pronto.
                    </AlertDescription>
                  </Alert>
                )}

                <form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <Label htmlFor="name">Nombre</Label>
                    <Input
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      placeholder="Tu nombre"
                      className="mt-1"
                    />
                  </div>

                  <div>
                    <Label htmlFor="email">Email</Label>
                    <Input
                      id="email"
                      name="email"
                      type="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="tu@email.com"
                      className="mt-1"
                    />
                  </div>

                  <div>
                    <Label htmlFor="subject">Asunto</Label>
                    <Input
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                      placeholder="¿Sobre qué querés escribirnos?"
                      className="mt-1"
                    />
                  </div>

                  <div>
                    <Label htmlFor="message">Mensaje</Label>
                    <Textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      placeholder="Describí tu consulta, sugerencia o problema..."
                      rows={6}
                      className="mt-1"
                    />
                  </div>

                  <Button 
                    type="submit" 
                    className="w-full bg-black hover:bg-gray-800 transition-colors"
                  >
                    <Send className="mr-2 h-4 w-4" />
                    Enviar mensaje
                  </Button>
                </form>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
